import React from "react";
import styles from "./WebDevComponent.module.css";
import { FaSalesforce, FaCode, FaCogs, FaSyncAlt, FaRobot } from "react-icons/fa";

const services = [
  {
    title: "AI Integration & Automation",
    icon: <FaRobot />,
    description:
      "Bring artificial intelligence into your workflow. I help small businesses integrate AI tools like ChatGPT, image recognition, automated email responders, and smart analytics into daily operations—so you can work faster and smarter.",
  },
  {
    title: "AI Training for Your Team",
    icon: <FaCogs />,
    description:
      "Confused by AI hype? I offer hands-on training to show your team how to use tools like ChatGPT, automation bots, and prompt engineering to increase efficiency, save time, and reduce costs without replacing your workforce.",
  },
  {
    title: "Salesforce + AI Solutions",
    icon: <FaSalesforce />,
    description:
      "I combine Salesforce development with AI to create intelligent CRM workflows that auto-fill data, prioritize leads, generate responses, and free up your sales team to focus on real conversations.",
  },
  {
    title: "System Integration & Workflow Automation",
    icon: <FaSyncAlt />,
    description:
      "From CRMs and schedulers to AI APIs and third-party tools, I connect the dots so your systems talk to each other—reducing bottlenecks and saving hours every week.",
  },
];

const WebDevComponent = () => {
  return (
    <section className={styles.services}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Smarter Tech. Faster Growth.</h2>
        <p className={styles.sectionSubtitle}>
          Ready to bring AI into your business without the buzzwords? I make advanced automation simple, practical, and profitable—whether you're a solopreneur or scaling team.
        </p>
        <div className={styles.servicesGrid}>
          {services.map((service, index) => (
            <div className={styles.serviceCard} key={index}>
              <div className={styles.icon}>{service.icon}</div>
              <h3 className={styles.serviceTitle}>{service.title}</h3>
              <p className={styles.serviceDescription}>{service.description}</p>
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.contactButton}
            onClick={() => window.location.href = "/contact"}
          >
            Let’s Talk AI for Your Business
          </button>
        </div>
      </div>
    </section>
  );
};

export default WebDevComponent;
